import React from 'react';

export const FRUIT: readonly string[] = ['🐝'];
export const FRUIT_NAMES: readonly string[] = ['Bee'];
export const FruitEmojiContext = React.createContext(FRUIT[0]);